import * as Yup from 'yup'

import {
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME,
  REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH,
} from './RequestProfileTabActivitiesAddPhaseModal.constants'

export function getRequestProfileTabActivitiesAddPhaseModalValidationSchema(t) {
  return Yup.object({
    [REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME]:
      Yup.string()
        .ensure()
        .trim()
        .required(() => true)
        .max(
          REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH,
          t('Error.MaxLengthKey', {
            length:
              REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_NAME_MAX_LENGTH,
          })
        ),
  })
}

export function getRequestProfileTabActivitiesAddPhaseModalPayload({
  pipelineId,
  position,
  values,
}) {
  return {
    ...(position == null ? null : { position }),
    name: values[
      REQUEST_PROFILE_TAB_ACTIVITIES_ADD_PHASE_MODAL_FIELD_NAME_NAME
    ].trim(),
    pipeline: pipelineId,
  }
}
